// Sell-form UI strings are provided by window.SELL_FORM_I18N
// (emitted from locales/*.json via the i18n snippet — see t() below).

new Vue({
  el: '#app-sell-form',
  components: {
        'app-sell-form-com': {
          props: ["locale", "terms", "title", "text_top", "text_bottom", "image", "overview_title", "overview_text", "contact_title", "contact_text", "popup_title", "popup_text", "success_title", "success_text", "success_text_2", "failed_title", "failed_text", "form_page_url"],
          template: `
            <form class="product-form product-form-multi margin-top" method="POST" :lang="langCode">
                <div v-if="showModal" class="form-overlay"></div>
                <div v-if="showModal" class="addedModal">
                  <button class="btn-icon" @click.prevent="closeModal">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M6.44929 5.99808L9.82609 2.61798C9.88566 2.55811 9.91908 2.47707 9.91902 2.39261C9.91896 2.30816 9.88544 2.22716 9.82579 2.16737C9.70639 2.04857 9.49608 2.04798 9.37548 2.16798L5.99958 5.54807L2.62249 2.16707C2.50249 2.04857 2.29219 2.04917 2.17279 2.16767C2.14315 2.19719 2.11969 2.23232 2.10377 2.271C2.08786 2.30968 2.0798 2.35115 2.08009 2.39298C2.08009 2.47818 2.11309 2.55798 2.17279 2.61708L5.54958 5.99778L2.17309 9.37878C2.1135 9.43874 2.08013 9.51988 2.0803 9.60441C2.08047 9.68894 2.11416 9.76995 2.17399 9.82968C2.23189 9.88697 2.31379 9.91998 2.39839 9.91998H2.40019C2.48509 9.91968 2.56699 9.88638 2.62369 9.82848L5.99958 6.44838L9.37668 9.82938C9.43638 9.88878 9.51619 9.92178 9.60079 9.92178C9.6426 9.92182 9.684 9.91361 9.72264 9.89763C9.76128 9.88164 9.79638 9.8582 9.82594 9.82864C9.85551 9.79907 9.87895 9.76397 9.89494 9.72533C9.91092 9.68669 9.91912 9.64529 9.91908 9.60348C9.91908 9.51858 9.88609 9.43848 9.82609 9.37937L6.44929 5.99808Z" fill="#5C5C5C"></path></svg>
                  </button>
                  <div>
                    <h3>{{popup_title}}</h3>
                    <p>{{popup_text}}</p>
                    <div class="flex btn-wrapper">
                        <button class="btn btn-secondary" :disabled="!isProductValid || hasReachedMaxItems" @click.prevent="addItem">{{ t.addAnotherItem }}</button>
                        <button class="btn" :disabled="!isProductValid" @click.prevent="addItemAndNext">{{ t.continue }}</button>
                    </div>
                  </div>
                </div>
                <div v-if="currentStep === 0" class="step front-view">
                    <div class="col-text">
                        <h2 class="section-title">{{title}}</h2>
                        <div v-html="text_top"></div>
                        <a v-if="form_page_url" class="btn" :href="form_page_url" target="_blank" rel="noopener">{{ t.startHere }}</a>
                        <button v-else class="btn" @click.prevent="goToAddItem">{{ t.startHere }}</button>
                    </div>
                    <div class="col-img">
                        <img :src="image">
                    </div>
                </div>
                <div v-if="currentStep === 1" class="step step-1 step-furniture">
                    <ol class="progress-bar">
                        <li class="active">{{ t.stepAboutItem }} <span>{{ t.step1of3 }}</span></li>
                        <li :class="{ clickable: hasItems }" @click.prevent="goToStep(2)">{{ t.stepOverview }}</li>
                        <li :class="{ clickable: hasItems }" @click.prevent="goToStep(3)">{{ t.stepContact }}</li>
                    </ol>
                    <div class="grid-col-all">
                      <h3>{{ t.addOneAtATime }}</h3>
                      <p>{{ itemName ? (itemType ? itemName + ' ' + itemType : itemName) : (itemType ? itemType : t.unnamedItem + ' ' + getDisplayIndex()) }}</p>
                    </div>
                    <div class="col-input">
                        <div class="inputs">
                          <label :class="{ invalid: !validationState.item.type }">
                              <span class="label-text">{{ t.itemTypeLabel }}</span>
                              <span>
                                <input name="mobeltype__f_eks__sofa_" type="text" :placeholder="t.itemTypePlaceholder" v-model="itemType" :maxLength="maxLength" :title="t.pleaseFill" required>
                              </span>
                          </label>
                          <label :class="{ invalid: !validationState.item.name }">
                              <span class="label-text">{{ t.itemNameLabel }}</span>
                              <span>
                                <input name="evt__design__eller_producentnavn" type="text" :placeholder="t.itemNamePlaceholder" v-model="itemName" :maxLength="maxLength" required>
                              </span>
                          </label>
                           <label :class="{ invalid: !validationState.item.material }">
                             <span class="label-text">{{ t.materialLabel }}</span>
                              <span>
                                <input name="materiale_r_" type="text" :placeholder="t.materialPlaceholder" v-model="itemMaterial"  :title="t.pleaseFill" :maxLength="maxLength" required>
                              </span>
                          </label>
                          <label :class="{ invalid: !validationState.item.price }">
                            <span class="label-text">{{ t.priceLabel }}</span>
                              <span>
                                <input name="din_forventede_pris_til_moblet_" type="text" :placeholder="t.pricePlaceholder" v-model="itemPrice" :maxLength="maxLengthShort" required>
                              </span>
                          </label>
                          <label :class="{ invalid: !validationState.item.trade }">
                              {{ t.tradeQuestion }}
                              <div class="flex flex-gap-x2">
                                  <label class="label-checkbox">
                                      <span>
                                        <input name="interesseret_i_byttehandel_" type="radio" value="Ja" v-model="itemTrade" :title="t.pleaseSelect" required>
                                      </span>
                                      {{ t.yes }}
                                  </label>
                                  <label class="label-checkbox">
                                      <span>
                                        <input name="interesseret_i_byttehandel_" type="radio" value="Nej" v-model="itemTrade" :title="t.pleaseSelect" required>
                                      </span>
                                      {{ t.no }}
                                  </label>
                              </div>
                          </label>
                          <label :class="{ invalid: !validationState.item.receipt }">
                              {{ t.receiptQuestion }}
                              <div class="flex flex-gap-x2">
                                  <label class="label-checkbox">
                                      <span>
                                        <input name="har_du_kvittering_" type="radio" value="Ja" v-model="itemReceipt" :title="t.pleaseSelect" required>
                                      </span>
                                      {{ t.yes }}
                                  </label>
                                  <label class="label-checkbox">
                                      <span>
                                        <input name="har_du_kvittering_" type="radio" value="Nej" v-model="itemReceipt" :title="t.pleaseSelect" required>
                                      </span>
                                      {{ t.no }}
                                  </label>
                              </div>
                          </label>
                          <label class="col-span-2 full-height" :class="{ invalid: !validationState.item.comment }">
                              <span class="label-text">{{ t.describeItemLabel }}</span>
                              <span class="full-height">
                                <textarea name="fort_l_os_om_genstanden" rows="8" :placeholder="t.describeItemPlaceholder" v-model="itemComment" :title="t.pleaseFill" required :minLength="minLength" :maxLength="maxLengthTextArea"></textarea>
                              </span>
                          </label>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label :class="{ invalid: !validationState.item.images }">
                                <span class="label-text">{{ t.uploadLabel }}</span>
                            </label>
                            <div :class="['images-preview', { empty: imagePreviews.length === 0 }, { full: imagePreviews.length === 8 }]" @click.stop>
                                <div v-for="(image, index) in imagePreviews" :key="index" :class="['img-container', 'img-state-' + (imageStates[index] || 'uploaded')]">
                                    <img :src="image" :alt="t.fileStored">
                                    <div v-if="imageStates[index] === 'uploading'" class="img-status img-status--uploading" aria-live="polite">
                                        <div class="img-status__spinner"></div>
                                        <span class="img-status__text">{{ t.uploadInProgress }}</span>
                                    </div>
                                    <div v-else-if="imageStates[index] === 'failed'" class="img-status img-status--failed" aria-live="assertive">
                                        <span class="img-status__text">{{ imageErrors[index] || t.uploadFailed }}</span>
                                        <button class="img-status__retry" @click.stop.prevent="retryImageUpload(index)">{{ t.tryAgain }}</button>
                                    </div>
                                    <button @click.stop.prevent="removeImage(index)" class="btn-icon">
                                        <svg class="icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M6.44929 5.99808L9.82609 2.61798C9.88566 2.55811 9.91908 2.47707 9.91902 2.39261C9.91896 2.30816 9.88544 2.22716 9.82579 2.16737C9.70639 2.04857 9.49608 2.04798 9.37548 2.16798L5.99958 5.54807L2.62249 2.16707C2.50249 2.04857 2.29219 2.04917 2.17279 2.16767C2.14315 2.19719 2.11969 2.23232 2.10377 2.271C2.08786 2.30968 2.0798 2.35115 2.08009 2.39298C2.08009 2.47818 2.11309 2.55798 2.17279 2.61708L5.54958 5.99778L2.17309 9.37878C2.1135 9.43874 2.08013 9.51988 2.0803 9.60441C2.08047 9.68894 2.11416 9.76995 2.17399 9.82968C2.23189 9.88697 2.31379 9.91998 2.39839 9.91998H2.40019C2.48509 9.91968 2.56699 9.88638 2.62369 9.82848L5.99958 6.44838L9.37668 9.82938C9.43638 9.88878 9.51619 9.92178 9.60079 9.92178C9.6426 9.92182 9.684 9.91361 9.72264 9.89763C9.76128 9.88164 9.79638 9.8582 9.82594 9.82864C9.85551 9.79907 9.87895 9.76397 9.89494 9.72533C9.91092 9.68669 9.91912 9.64529 9.91908 9.60348C9.91908 9.51858 9.88609 9.43848 9.82609 9.37937L6.44929 5.99808Z" fill="#5C5C5C"/>
                                        </svg>
                                    </button>
                                </div>
                                <div id="drag-upload">
                                    <input name="uploaded_fil" type="file" id="images" @change="handleFileUpload" multiple accept="image/jpeg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp" :title="t.uploadTitle" :disabled="images.length >= 8">
                                    <div>
                                        <svg class="icon" width="44" height="29" viewBox="0 0 44 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M13.1111 11.7932L2 28.0038H42L27.1852 5.89844L21.2593 16.2143L13.1111 11.7932Z" fill="#5C5C5C" stroke="#5C5C5C" stroke-width="1.48148"/>
                                          <ellipse cx="7.18468" cy="4.42108" rx="4.44444" ry="4.42108" fill="#5C5C5C"/>
                                        </svg>
                                        <p>{{ t.uploadText }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex btn-wrapper">
                            <p v-if="hasUploadsInProgress" class="form-required-hint form-required-hint--save">{{ t.uploadsInProgressHint }}</p>
                            <p v-else-if="hasFailedUploads" class="form-required-hint form-required-hint--save">{{ t.uploadsFailedHint }}</p>
                            <p v-else-if="hasInvalidItemField" class="form-required-hint form-required-hint--save">{{ t.fillAllToSave }}</p>
                            <button v-if="hasItems && editingIndex === null" class="btn btn-secondary" @click.prevent="cancelAddItem">{{ t.cancel }}</button>
                            <button class="btn" :class=" { disabled: !isProductValid || hasReachedMaxItems}" @click.prevent="openModal">{{ t.save }}</button>
                        </div>
                        <p class="info-text">{{text_bottom}}</p>
                    </div>
                </div>
                <div v-if="currentStep === 2" id="step-overview" class="step step-2">
                    <ol class="progress-bar">
                        <li>{{ t.stepAboutItem }}</li>
                        <li class="active">{{ t.stepOverview }} <span>{{ t.step2of3 }}</span></li>
                        <li :class="{ clickable: hasItems }" @click.prevent="goToStep(3)">{{ t.stepContact }}</li>
                    </ol>
                    <div>
                        <h3>{{overview_title}}</h3>
                        <p>{{overview_text}}</p>
                        <div class="product-overview">
                            <div class="product" v-for="(item, index) in itemOverview" :key="index">
                                <div>
                                    <h4>{{item.name}} {{item.type}}</h4>
                                    <p>
                                      {{ item.price ? t.expectedPrice + item.price + ' DKK' : '' }}
                                      {{ item.price && item.trade ? ' | ' : '' }}
                                      {{ item.trade ? t.trade + item.trade : '' }}
                                    </p>
                                </div>
                                <div class="flex flex-gap-x1-5">
                                    <button class="btn-icon" @click.prevent="removeItem(index)">
                                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_171_6134)">
                                        <path d="M12.375 2.08594C6.6825 2.08594 2.0625 6.7526 2.0625 12.5026C2.0625 18.2526 6.6825 22.9193 12.375 22.9193C18.0675 22.9193 22.6875 18.2526 22.6875 12.5026C22.6875 6.7526 18.0675 2.08594 12.375 2.08594ZM17.5312 13.5443H7.21875V11.4609H17.5312V13.5443Z" fill="#5C5C5C"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_171_6134">
                                        <rect width="24.75" height="25" fill="white"/>
                                        </clipPath>
                                        </defs>
                                      </svg>
                                      <span>{{ t.delete }}</span>
                                    </button>
                                    <button class="btn-icon" @click.prevent="editItem(index)">
                                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_171_6133)">
                                        <path d="M3.34375 18.1901V21.3568C3.34375 21.6484 3.57062 21.8776 3.85938 21.8776H6.99437C7.12844 21.8776 7.2625 21.8255 7.35531 21.7214L18.6166 10.3568L14.7494 6.45052L3.49844 17.8151C3.39531 17.9193 3.34375 18.0443 3.34375 18.1901ZM21.6072 7.33594C22.0094 6.92969 22.0094 6.27344 21.6072 5.86719L19.1941 3.42969C18.7919 3.02344 18.1422 3.02344 17.74 3.42969L15.8528 5.33594L19.72 9.24219L21.6072 7.33594Z" fill="#5C5C5C"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_171_6133">
                                        <rect width="24.75" height="25" fill="white" transform="translate(0.25)"/>
                                        </clipPath>
                                        </defs>
                                      </svg>
                                      <span>{{ t.edit }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex btn-wrapper">
                        <button class="btn btn-secondary" :disabled="hasReachedMaxItems" @click.prevent="goToAddItem">{{ t.addItem }}</button>
                        <button class="btn" :disabled="!hasItems" @click.prevent="goToContactSlide">{{ t.next }}</button>
                    </div>
                </div>
                <div v-if="currentStep === 3 && !isLoading" id="step-contact" class="step step-3">
                    <ol class="progress-bar">
                        <li>{{ t.stepAboutItem }}</li>
                        <li :class="{ clickable: hasItems }" @click.prevent="goToStep(2)">{{ t.stepOverview }}</li>
                        <li class="active">{{ t.stepContact }} <span>{{ t.step3of3 }}</span></li>
                    </ol>
                    <div>
                        <h3>{{contact_title}}</h3>
                        <p>{{contact_text}}</p>
                        <div class="col-contact-input">
                            <label :class="{ invalid: !validationState.name }">
                                <span class="label-text">{{ t.nameLabel }}</span>
                                <span>
                                  <input autocomplete="name" name="firstname" type="text" :placeholder="t.namePlaceholder" :title="t.pleaseFill" required v-model="contactInfo.name">
                                </span>
                            </label>
                            <label :class="{ invalid: !validationState.phone }">
                                <span class="label-text">{{ t.phoneLabel }}</span>
                                <span>
                                  <input autocomplete="tel" name="phone" type="tel" :placeholder="t.phonePlaceholder" :title="t.pleaseFill" required v-model="contactInfo.phone">
                                </span>
                            </label>
                            <label :class="{ invalid: !validationState.postalCode }">
                                <span class="label-text">{{ t.postalLabel }}</span>
                                <span>
                                  <input autocomplete="postal-code" name="postnummer" type="text" :placeholder="t.postalPlaceholder" :title="t.pleaseFill" required v-model="contactInfo.postalCode">
                                </span>
                            </label>
                            <label :class="{ invalid: !validationState.email }">
                                <span class="label-text">{{ t.emailLabel }}</span>
                                <span>
                                  <input autocomplete="email" name="email" ref="emailInput" type="email" :placeholder="t.emailPlaceholder" :title="t.pleaseFill" required v-model="contactInfo.email">
                                </span>
                            </label>
                            <label id="dataconsent" class="label-checkbox" :class="{ invalid: !validationState.dataConsent }">
                                <span>
                                  <input name="jeg_accepterer_vilkar_og_betingelser" type="checkbox" :title="t.pleaseCheck" required v-model="hasDataConsent">
                                </span>
                                <span>{{ t.iAccept }} <a :href="terms" target="_blank">
                                  {{ t.termsAndConditions }}
                                </a></span>
                            </label>
                        </div>
                        <div v-if="submitError" class="form-submit-error" role="alert">{{ submitError }}</div>
                        <div class="flex btn-wrapper">
                            <p v-if="hasInvalidContactField" class="form-required-hint form-required-hint--send">{{ t.fillAllToSend }}</p>
                            <button class="btn btn-secondary" :disabled="isLoading" @click.prevent="goToOverviewSlide">{{ t.previous }}</button>
                            <button type="submit" class="btn" :class="{ disabled: isLoading || !isFormValid }" @click.prevent="submitForm">
                              <span>{{ t.send }}</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="isLoading" id="step-final" class="step">
                    <div class="spinner"></div>
                    <p>{{ t.loadingText }}</p>
                </div>
                <div v-if="currentStep === 4" id="step-final" class="step">
                    <h3>{{success_title}}</h3>
                    <p>{{success_text}}</p><br>
                    <p class="bold">{{success_text_2}}</p>
                    <button class="btn" @click="goToAddItem">{{ t.sendNewMessage }}</button>
                </div>
                <div v-if="currentStep === 5" id="step-error" class="step">
                    <h3>{{failed_title}}</h3>
                    <p>{{failed_text}}</p>
                    <button class="btn" @click="goToOverviewSlide">{{ t.tryAgain }}</button>
                </div>
            </form>
          `,
          data() {
            return {
              maxLength: 45,
              maxLengthShort: 25,
              maxLengthTextArea: 380,
              minLength: 10,
              itemName: "",
              itemType: "",
              itemMaterial: "",
              itemPrice: "",
              itemTrade: "",
              itemReceipt: "",
              itemComment: "",
              itemOverview: [],
              images: [],
              imagePreviews: [],
              imageStates: [],        // 'uploading' | 'uploaded' | 'failed' per image
              imageErrors: [],        // user-facing error string per image
              imageUploadUrls: [],    // server URL per image once uploaded
              maxFileSizeBytes: 10 * 1024 * 1024, // 10 MB
              sessionId: this.localTicketId("SK"),
              submitError: '',        // user-facing error shown on contact step when Send fails
              contactInfo: {
                  name: "",
                  phone: "",
                  postalCode: "",
                  email: ""
              },
              hasDataConsent: false,
              currentStep: 0,
              editingIndex: null,  
              maxItems: 4,
              isLoading: false,
              showModal: false,
              validationState: {
                  name: true,
                  phone: true,
                  postalCode: true,
                  email: true,
                  dataConsent: true,
                  item: {
                    name: true,
                    type: true,
                    material: true,
                    price: true,
                    trade: true,
                    receipt: true,
                    comment: true,
                    images: true
                  }
              }
            }
          },
          computed: {
              isProductValid() {
                    const itemName = this.itemName.trim().length > 0 && this.itemName.trim().length <= this.maxLength;
                    const itemType = this.itemType.trim().length > 0 && this.itemType.trim().length <= this.maxLength;
                    const itemMaterial = this.itemMaterial.trim().length > 0 && this.itemMaterial.trim().length <= this.maxLength;
                    const itemPrice = this.itemPrice.trim().length > 0 && this.itemPrice.trim().length <= this.maxLengthShort;
                    const itemTrade = this.itemTrade.trim().length > 0;
                    const itemReceipt = this.itemReceipt.trim().length > 0;
                    const itemComment = this.itemComment.trim().length >= this.minLength && this.itemComment.trim().length <= this.maxLengthTextArea;
                    const hasImages = this.images.length > 0 && this.imagePreviews.length > 0;
                    const allImagesUploaded = this.imageStates.length === this.images.length && this.imageStates.every(s => s === 'uploaded');

                    return itemName && itemType && itemMaterial && itemPrice && itemTrade && itemReceipt && itemComment && hasImages && allImagesUploaded;
                },
              hasUploadsInProgress() {
                    return this.imageStates.some(s => s === 'uploading');
                },
              hasFailedUploads() {
                    return this.imageStates.some(s => s === 'failed');
                },
              isFormValid(){
                  const isEmailValid = this.$refs.emailInput?.checkValidity(); 
                  var hasRequiredFields = this.contactInfo.name != "" && this.contactInfo.phone != "" && this.contactInfo.postalCode != "" && this.contactInfo.email != "" && isEmailValid && this.hasDataConsent;
                  return hasRequiredFields;
              },
              hasInvalidItemField() {
                  const v = this.validationState.item;
                  return !v.type || !v.name || !v.material || !v.price || !v.trade || !v.receipt || !v.comment || !v.images;
              },
              hasInvalidContactField() {
                  const v = this.validationState;
                  return !v.name || !v.phone || !v.postalCode || !v.email || !v.dataConsent;
              },
              hasReachedMaxItems() {
                  if (this.currentStep === 1) {
                      return this.itemOverview.length >= this.maxItems - 1;
                  } else if (this.currentStep === 2) {
                      return this.itemOverview.length >= this.maxItems; 
                  }
                  return false;
              },
              hasItems() {
                  return this.itemOverview.length > 0;
              },
              langCode() {
                  return (this.locale || 'da').split('-')[0].toLowerCase();
              },
              t() {
                  // Strings come from locales/*.json via the {% render 'sell-form-i18n' %}
                  // snippet (managed in the Shopify language editor / Translate & Adapt).
                  return window.SELL_FORM_I18N || {};
              }
          },

          watch: {
              showModal(isOpen) {
                  if (isOpen) {
                      const header = document.getElementById('shopify-section-header');
                      let headerH = 0;
                      if (header) {
                          headerH = Math.max(0, header.getBoundingClientRect().bottom);
                      }
                      document.documentElement.style.setProperty('--sticky-header-h', headerH + 'px');
                      document.body.classList.add('sell-form-modal-open');
                  } else {
                      document.body.classList.remove('sell-form-modal-open');
                  }
              },
              currentStep() {
                  this.$nextTick(() => {
                      const formEl = document.getElementById('app-sell-form');
                      if (!formEl) return;
                      const header = document.getElementById('shopify-section-header');
                      let offset = 0;
                      if (header) {
                          offset = Math.max(0, header.getBoundingClientRect().bottom);
                      }
                      const formTop = formEl.getBoundingClientRect().top + window.scrollY;
                      window.scrollTo({
                          top: formTop - offset,
                          behavior: 'smooth'
                      });
                  });
              },
              itemType(val) {
                  this.validationState.item.type = val.trim().length > 0 && val.trim().length <= this.maxLength;
              },
              itemName(val) {
                  this.validationState.item.name = val.trim().length > 0 && val.trim().length <= this.maxLength;
              },
              itemMaterial(val) {
                  this.validationState.item.material = val.trim().length > 0 && val.trim().length <= this.maxLength;
              },
              itemPrice(val) {
                  this.validationState.item.price = val.trim().length > 0 && val.trim().length <= this.maxLengthShort;
              },
              itemTrade(val) {
                  this.validationState.item.trade = val.trim().length > 0;
              },
              itemReceipt(val) {
                  this.validationState.item.receipt = val.trim().length > 0;
              },
              itemComment(val) {
                  this.validationState.item.comment = val.trim().length >= this.minLength && val.trim().length <= this.maxLengthTextArea;
              },
              imagePreviews(val) {
                  this.validationState.item.images = this.images.length > 0 && val.length > 0;
              },
              hasDataConsent(val) {
                  this.validationState.dataConsent = val;
              },
              'contactInfo.name'(val) {
                  this.validationState.name = val.trim().length > 0;
              },
              'contactInfo.phone'(val) {
                  this.validationState.phone = val.trim().length > 0;
              },
              'contactInfo.postalCode'(val) {
                  this.validationState.postalCode = val.trim().length > 0;
              },
              'contactInfo.email'(val) {
                  const emailInput = this.$refs.emailInput;
                  this.validationState.email = emailInput ? emailInput.checkValidity() : false;
              }
          },

          methods: {
            // Reference number shown in HubSpot and the receipt mail, e.g. SK-4821-26.
            // The server hands out random numbers it has not used before this year.
            async fetchTicketId(prefix) {
                try {
                    const controller = new AbortController();
                    const timer = setTimeout(() => controller.abort(), 5000);
                    const response = await fetch(`https://files.klassik.dk/ticketNumber.php?prefix=${prefix}`, { method: "POST", signal: controller.signal });
                    clearTimeout(timer);
                    const id = (await response.text()).trim();
                    if (response.ok && new RegExp(`^${prefix}-\\d{4}-\\d{2}$`).test(id)) {
                        return id;
                    }
                } catch (_) {}
                return this.localTicketId(prefix);
            },
            // Fallback when the server is unreachable: random, but not checked for duplicates.
            localTicketId(prefix) {
                const year = String(new Date().getFullYear()).slice(-2);
                return `${prefix}-${Math.floor(1000 + Math.random() * 9000)}-${year}`;
            },
            goToStep(stepIndex) {
                if (this.hasItems) {
                    this.currentStep = stepIndex;
                }
            },
            getDisplayIndex() {
                return this.editingIndex !== null ? this.editingIndex + 1 : this.itemOverview.length + 1;
            },
            validateFields() {
                if (this.currentStep === 1) {
                    this.validationState.item.name = this.itemName.trim().length > 0 && this.itemName.trim().length <= this.maxLength;
                    this.validationState.item.type = this.itemType.trim().length > 0 && this.itemType.trim().length <= this.maxLength;
                    this.validationState.item.material = this.itemMaterial.trim().length > 0 && this.itemMaterial.trim().length <= this.maxLength;
                    this.validationState.item.price = this.itemPrice.trim().length > 0 && this.itemPrice.trim().length <= this.maxLengthShort;
                    this.validationState.item.trade = this.itemTrade.trim().length > 0;
                    this.validationState.item.receipt = this.itemReceipt.trim().length > 0;
                    this.validationState.item.comment = this.itemComment.trim().length >= this.minLength && this.itemComment.trim().length <= this.maxLengthTextArea;
                    const hasImages = this.images.length > 0 && this.imagePreviews.length > 0;
                    const allUploaded = this.imageStates.length === this.images.length && this.imageStates.every(s => s === 'uploaded');
                    this.validationState.item.images = hasImages && allUploaded;

                    return this.validationState.item.name &&
                        this.validationState.item.type &&
                        this.validationState.item.material &&
                        this.validationState.item.price &&
                        this.validationState.item.trade &&
                        this.validationState.item.receipt &&
                        this.validationState.item.comment &&
                        this.validationState.item.images;
                }

                if (this.currentStep === 3) {
                    this.validationState.name = this.contactInfo.name.trim().length > 0;
                    this.validationState.phone = this.contactInfo.phone.trim().length > 0;
                    this.validationState.postalCode = this.contactInfo.postalCode.trim().length > 0;

                    const emailInput = this.$refs.emailInput;
                    this.validationState.email = emailInput ? emailInput.checkValidity() : false;

                    this.validationState.dataConsent = this.hasDataConsent;

                    return this.validationState.name &&
                        this.validationState.phone &&
                        this.validationState.postalCode &&
                        this.validationState.email &&
                        this.validationState.dataConsent;
                }

                return false;
            },
            getCookie(cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for(var i = 0; i <ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                    }
                }
                return null;
            },
            goToAddItem(){
                this.currentStep = 1;
            },
            goToOverviewSlide(){
                this.currentStep = 2;
            },
            goToContactSlide(){
                if(this.hasItems){
                    this.currentStep = 3;
                }
            },
            addItem() {
                if (!this.hasReachedMaxItems){
                    this.closeModal();
                    this.pushItemToOverview();
                    this.clearProductForm();
                }
            },
            openModal() {
              if(this.validateFields()){
                this.showModal = true;
              }
            },
            closeModal() {
              this.showModal = false;
            },
            addItemAndNext() {
                if(this.isProductValid){
                    this.closeModal();
                    this.pushItemToOverview();
                    this.clearProductForm();
                    this.currentStep = 2;
                }
            },
            pushItemToOverview() {
                let item = {
                    name: this.itemName,
                    type: this.itemType,
                    material: this.itemMaterial,
                    price: this.itemPrice,
                    trade: this.itemTrade,
                    receipt: this.itemReceipt,
                    comment: this.itemComment,
                    images: this.images.slice(),
                    imagePreviews: this.imagePreviews.slice(),
                    imageStates: this.imageStates.slice(),
                    imageErrors: this.imageErrors.slice(),
                    imageUploadUrls: this.imageUploadUrls.slice()
                };
                if (this.editingIndex === null) {
                    // Add new item
                    this.itemOverview.push(item);
                } else {
                    // Update existing item
                    this.itemOverview.splice(this.editingIndex, 1, item);
                    this.editingIndex = null;
                }
            },
            cancelAddItem() {
                this.clearProductForm();
                this.editingIndex = null;
                this.currentStep = 2;
            },
            clearProductForm() {
                this.itemName = "";
                this.itemType = "";
                this.itemMaterial = "";
                this.itemPrice = "";
                this.itemTrade = "";
                this.itemReceipt = "";
                this.itemComment = "";
                this.images = [];
                this.imagePreviews = [];
                this.imageStates = [];
                this.imageErrors = [];
                this.imageUploadUrls = [];
            },
            clearForm() {
                // New reference number for the next enquiry (the page is not reloaded).
                this.sessionId = this.localTicketId("SK");
                this.itemName = "";
                this.itemType = "";
                this.itemMaterial = "";
                this.itemPrice = "";
                this.itemTrade = "";
                this.itemReceipt = "";
                this.itemComment = "";
                this.itemOverview = [];
                this.images = [];
                this.imagePreviews = [];
                this.imageStates = [];
                this.imageErrors = [];
                this.imageUploadUrls = [];

                this.contactInfo.name = "";
                this.contactInfo.phone = "";
                this.contactInfo.postalCode = "";
                this.contactInfo.email = "";

                this.hasDataConsent = false;
                this.currentStep = 1;
                this.editingIndex = null;
                this.submitError = '';
            },
            removeItem(index) {
                this.itemOverview.splice(index, 1);
            },
            editItem(index) {
                let item = this.itemOverview[index];
                this.itemName = item.name;
                this.itemType = item.type;
                this.itemMaterial = item.material;
                this.itemPrice = item.price;
                this.itemTrade = item.trade;
                this.itemReceipt = item.receipt;
                this.itemComment = item.comment;
                this.images = item.images.slice();
                this.imagePreviews = item.imagePreviews.slice();
                this.imageStates = (item.imageStates || item.images.map(() => 'uploaded')).slice();
                this.imageErrors = (item.imageErrors || item.images.map(() => '')).slice();
                this.imageUploadUrls = (item.imageUploadUrls || item.images.map(() => '')).slice();
                this.editingIndex = index;
                this.currentStep = 1;
            },
            handleFileUpload(event) {
                let files = Array.from(event.target.files);

                if (this.images.length + files.length > 8) {
                    alert(this.t.maxImagesAlert);
                    event.target.value = null;
                    return;
                }

                const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
                const invalidTypeFiles = files.filter(f => !allowedTypes.includes(f.type));
                if (invalidTypeFiles.length > 0) {
                    const names = invalidTypeFiles.map(f => `${f.name} (${f.type || 'ukendt format'})`).join(', ');
                    alert(this.t.invalidTypeAlert.replace('{names}', names));
                    files = files.filter(f => allowedTypes.includes(f.type));
                    if (files.length === 0) {
                        event.target.value = null;
                        return;
                    }
                }

                const emptyFiles = files.filter(f => f.size === 0);
                if (emptyFiles.length > 0) {
                    const names = emptyFiles.map(f => f.name).join(', ');
                    alert(this.t.emptyFileAlert.replace('{names}', names));
                    files = files.filter(f => f.size > 0);
                    if (files.length === 0) {
                        event.target.value = null;
                        return;
                    }
                }

                const tooLargeFiles = files.filter(f => f.size > this.maxFileSizeBytes);
                if (tooLargeFiles.length > 0) {
                    tooLargeFiles.forEach(f => {
                        const sizeMb = (f.size / 1024 / 1024).toFixed(1);
                        alert(this.t.tooLargeAlert.replace('{name}', f.name).replace('{size}', sizeMb));
                    });
                    files = files.filter(f => f.size <= this.maxFileSizeBytes);
                    if (files.length === 0) {
                        event.target.value = null;
                        return;
                    }
                }

                files.forEach(file => {
                    const index = this.images.length;
                    this.images.push(file);
                    this.imagePreviews.push('');
                    this.imageStates.push('uploading');
                    this.imageErrors.push('');
                    this.imageUploadUrls.push('');

                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const i = this.images.indexOf(file);
                        if (i !== -1) {
                            this.imagePreviews.splice(i, 1, e.target.result);
                        }
                    };
                    reader.onerror = () => {
                        const i = this.images.indexOf(file);
                        if (i !== -1) {
                            this.removeImage(i);
                        }
                        alert(this.t.readFailedAlert.replace('{name}', file.name));
                    };
                    reader.readAsDataURL(file);

                    // Start upload immediately
                    this.uploadImageAt(index, false);
                });

                event.target.value = null;
            },
            async uploadImageAt(index, isRetry) {
                const file = this.images[index];
                if (!file) return;

                this.imageStates.splice(index, 1, 'uploading');
                this.imageErrors.splice(index, 1, '');
                this.imageUploadUrls.splice(index, 1, '');

                try {
                    const url = await this.uploadImg(file);
                    // Make sure the file is still at this index (could have been removed)
                    if (this.images[index] === file) {
                        this.imageUploadUrls.splice(index, 1, url);
                        this.imageStates.splice(index, 1, 'uploaded');
                    }
                } catch (error) {
                    if (this.images[index] !== file) return; // file was removed during upload

                    this.imageStates.splice(index, 1, 'failed');
                    this.imageErrors.splice(index, 1, this.getUploadErrorMessage(error));

                    if (!isRetry) {
                        try {
                            await this.reportError('image_upload', {
                                ticketId: this.sessionId,
                                productIndex: this.editingIndex !== null ? this.editingIndex + 1 : this.itemOverview.length + 1,
                                fileInfo: error.fileInfo,
                                status: error.status,
                                statusText: error.statusText,
                                responseBody: error.responseBody,
                                networkError: error.networkError,
                                retriesAttempted: error.retriesAttempted,
                                message: error.message
                            });
                        } catch (_) { /* reportError swallows its own errors */ }
                    }
                }
            },
            retryImageUpload(index) {
                if (this.imageStates[index] === 'uploading') return;
                this.uploadImageAt(index, true);
            },
            getUploadErrorMessage(error) {
                if (error && error.status === 413) return this.t.uploadErrorTooLarge;
                if (error && error.status === 422) return this.t.uploadErrorUnreadable;
                if (error && error.responseBody && /empty or not fully available|could not be read/i.test(error.responseBody)) {
                    return this.t.uploadErrorUnreadable;
                }
                if (error && error.status >= 400 && error.status < 500) return this.t.uploadErrorClient;
                if (error && error.status >= 500) return this.t.uploadErrorServer;
                if (error && error.networkError) return this.t.uploadErrorNetwork;
                return this.t.uploadErrorGeneric;
            },
            removeImage(index) {
                this.images.splice(index, 1);
                this.imagePreviews.splice(index, 1);
                this.imageStates.splice(index, 1);
                this.imageErrors.splice(index, 1);
                this.imageUploadUrls.splice(index, 1);
            },
            async uploadImg(file) {
                const url = "https://files.klassik.dk/hubspotImageUpload.php";
                const fileInfo = file ? { name: file.name, size: file.size, type: file.type } : null;
                const maxRetries = 2; // 3 attempts total

                for (let attempt = 0; attempt <= maxRetries; attempt++) {
                    const formData = new FormData();
                    if (file) {
                        formData.append('file', file);
                    }

                    let response;
                    try {
                        response = await fetch(url, {
                            method: 'POST',
                            body: formData
                        });
                    } catch (networkErr) {
                        // Network-level failure (e.g. "Failed to fetch") — retry transient blips
                        if (attempt < maxRetries) {
                            await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
                            continue;
                        }
                        const err = new Error(`Image upload network error after ${maxRetries + 1} attempts: ${networkErr.message}`);
                        err.stage = 'image_upload';
                        err.fileInfo = fileInfo;
                        err.networkError = networkErr.message;
                        err.retriesAttempted = maxRetries;
                        throw err;
                    }

                    let responseText = '';
                    try { responseText = await response.text(); } catch (_) {}

                    if (!response.ok) {
                        // Server responded — a real rejection, retrying won't help
                        const err = new Error(`Image upload failed (HTTP ${response.status})`);
                        err.stage = 'image_upload';
                        err.status = response.status;
                        err.statusText = response.statusText;
                        err.responseBody = responseText;
                        err.fileInfo = fileInfo;
                        throw err;
                    }

                    if (responseText.includes("Error:")) {
                        const err = new Error(`Image upload returned error from server`);
                        err.stage = 'image_upload';
                        err.status = response.status;
                        err.responseBody = responseText;
                        err.fileInfo = fileInfo;
                        throw err;
                    }

                    return responseText;
                }
            },
            async submitForm() {
                if (this.validateFields()) {
                    this.submitError = '';
                    this.isLoading = true;

                    const url = "https://files.klassik.dk/hubspotSubmit.php?form=f1dc9b60-65a0-4abd-98df-f428d9fc3014";
                    let success = false;
                    let submitErrorDetails = null;

                    this.sessionId = await this.fetchTicketId("SK");
                    var uniqueId = this.sessionId;

                    const fields = [
                        { name: "ticketid", value: uniqueId },
                        { name: "firstname", value: this.contactInfo.name },
                        { name: "phone", value: this.contactInfo.phone },
                        { name: "email", value: this.contactInfo.email },
                        { name: "postnummer", value: this.contactInfo.postalCode },
                        { name: "jeg_accepterer_vilkar_og_betingelser", value: this.hasDataConsent }
                    ];

                    const context = {
                        hutk: this.getCookie("hubspotutk") || undefined,
                        pageUri: window.location.href,
                        pageName: document.title
                    };

                    // Images were uploaded eagerly at file-selection time.
                    // Just use the cached URLs — no re-upload needed.
                    for (let index = 0; index < this.itemOverview.length; index++) {
                        const item = this.itemOverview[index];
                        const imageFields = [];
                        item.uploadedImages = (item.imageUploadUrls || []).slice();

                        for (const uploadedUrl of item.uploadedImages) {
                            if (uploadedUrl) {
                                imageFields.push({ name: `uploaded_fil_${index + 1}`, value: uploadedUrl });
                            }
                        }

                        fields.push(
                            { name: `evt__design__eller_producentnavn_${index + 1}`, value: item.name },
                            { name: `mobeltype__f_eks__sofa__${index + 1}`, value: item.type },
                            { name: `materiale_r__${index + 1}`, value: item.material },
                            { name: `din_forventede_pris_til_moblet__${index + 1}__cloned_`, value: item.price },
                            { name: `interesseret_i_byttehandel__${index + 1}`, value: item.trade },
                            { name: `har_du_kvittering__${index + 1}`, value: item.receipt },
                            { name: `fort_l_os_om_genstanden_${index + 1}`, value: item.comment },
                            ...imageFields
                        );
                    }

                      const formData = { fields, context };
                      const maxSubmitRetries = 2; // 3 attempts total

                      for (let attempt = 0; attempt <= maxSubmitRetries; attempt++) {
                          try {
                              const response = await fetch(url, {
                                  method: "POST",
                                  // No Content-Type header: keeps this a CORS "simple request" (no preflight the server firewall could block).
                                  body: JSON.stringify(formData)
                              });

                              if (response.ok) {
                                  success = true;
                                  console.log("Form submitted successfully");
                                  break;
                              }

                              let responseBody = '';
                              try { responseBody = await response.text(); } catch (_) {}
                              console.error("HubSpot form submission error", response.status, responseBody);
                              submitErrorDetails = {
                                  status: response.status,
                                  statusText: response.statusText,
                                  responseBody: responseBody
                              };

                              // 5xx may be transient — retry. 4xx is a real rejection — stop.
                              if (response.status >= 500 && attempt < maxSubmitRetries) {
                                  await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
                                  continue;
                              }
                              break;
                          } catch (error) {
                              console.error("Error submitting form", error);
                              submitErrorDetails = {
                                  networkError: error.message,
                                  message: error.message
                              };
                              // Network errors are usually transient — retry.
                              if (attempt < maxSubmitRetries) {
                                  await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
                                  continue;
                              }
                              break;
                          }
                      }

                      if (success) {
                          try {
                              await this.sendMail(uniqueId);
                          } catch (mailError) {
                              console.error("Error sending email", mailError);
                              try {
                                  await this.reportError('confirmation_mail', {
                                      ticketId: uniqueId,
                                      message: mailError && mailError.message ? mailError.message : String(mailError)
                                  });
                              } catch (_) {}
                          }
                          this.clearForm();
                          this.isLoading = false;
                          this.currentStep = 4;
                      } else {
                          // Report to admin AFTER all retries have been exhausted
                          const totalAttempts = maxSubmitRetries + 1;
                          const reportPayload = Object.assign({
                              ticketId: uniqueId,
                              retriesAttempted: maxSubmitRetries
                          }, submitErrorDetails || {});
                          if (reportPayload.message) {
                              reportPayload.message = `HubSpot submit failed after ${totalAttempts} attempts: ${reportPayload.message}`;
                          } else {
                              reportPayload.message = `HubSpot submit failed after ${totalAttempts} attempts`;
                          }
                          try {
                              await this.reportError('hubspot_submit', reportPayload);
                          } catch (_) {}
                          this.submitError = this.getSubmitErrorMessage(submitErrorDetails);
                          this.isLoading = false;
                          // Stay on contact step so customer can correct + retry without losing data
                      }
                }
            },
            getSubmitErrorMessage(details) {
                if (!details) return this.t.submitErrorGeneric;
                if (details.networkError) return this.t.submitErrorNetwork;
                if (details.status >= 500) return this.t.submitErrorServer;
                if (details.status >= 400 && details.status < 500) {
                    return this.t.submitErrorRejected.replace('{status}', details.status);
                }
                return this.t.submitErrorGeneric;
            },
            async reportError(stage, errorDetails) {
                const itemsSummary = (this.itemOverview || []).map((item, idx) => ({
                    index: idx + 1,
                    type: item.type || '',
                    name: item.name || '',
                    material: item.material || '',
                    price: item.price || '',
                    trade: item.trade || '',
                    receipt: item.receipt || '',
                    comment: item.comment || '',
                    imageCount: (item.images || []).length
                }));

                // Kundens kontaktoplysninger SKAL med, ellers er leadet tabt når
                // indsendelsen til HubSpot fejler (fx blokeret af tracking-blocker).
                const c = this.contactInfo || {};
                const contact = {
                    name: c.name || '',
                    phone: c.phone || '',
                    email: c.email || '',
                    postalCode: c.postalCode || ''
                };
                const details = Object.assign({}, errorDetails || {});
                const contactLine = 'Kunde: ' + (contact.name || '-') +
                    ' | Tlf: ' + (contact.phone || '-') +
                    ' | E-mail: ' + (contact.email || '-') +
                    ' | Postnr: ' + (contact.postalCode || '-');
                details.message = details.message ? (details.message + ' — ' + contactLine) : contactLine;

                const payload = {
                    email_template: "form_error",
                    reciver_email: "obu@digitalpartners.dk",
                    params: {
                        stage: stage,
                        timestamp: new Date().toISOString(),
                        pageUrl: window.location.href,
                        userAgent: navigator.userAgent,
                        language: this.langCode,
                        contact: contact,
                        items: itemsSummary,
                        error: details
                    }
                };

                console.error('[app-sell-form] reporting error', payload);

                try {
                    const siteKey = '6LfIaoIqAAAAAMz4xm9Jm4LvIX48wDDVaOwe-LoM';
                    const token = await new Promise((resolve, reject) => {
                        if (typeof grecaptcha === 'undefined') {
                            reject(new Error('grecaptcha not loaded'));
                            return;
                        }
                        grecaptcha.ready(() => {
                            grecaptcha.execute(siteKey, { action: 'submit' })
                                .then(resolve)
                                .catch(reject);
                        });
                    });

                    await fetch(`https://files.klassik.dk/mails/index.php?token=${token}`, {
                        method: 'POST',
                        body: JSON.stringify(payload)
                    });
                } catch (reportErr) {
                    console.error('[app-sell-form] failed to send error report', reportErr);
                }
            },
            async sendMail(id) {
                  return new Promise((resolve, reject) => { 
                      const siteKey = '6LfIaoIqAAAAAMz4xm9Jm4LvIX48wDDVaOwe-LoM';
                      const self = this;
                      const currentYear = new Date().getFullYear();
              
                      grecaptcha.ready(() => {
                          grecaptcha.execute(siteKey, { action: 'submit' }).then((token) => {
                              const itemsForEmail = this.itemOverview.map(item => ({
                                  item_design_name: item.name || '',
                                  item_type: item.type || '',
                                  item_material: item.material || '',
                                  item_price: item.price || '',
                                  item_trade: item.trade || '',
                                  item_receipt: item.receipt || '',
                                  item_images: item.uploadedImages || [],
                                  item_comment: item.comment || ''
                              }));
                              
                              const payload = {
                                  email_template: "sale",
                                  reciver_email: self.contactInfo.email,
                                  params: {
                                      current_year: currentYear,
                                      id: id,
                                      name: self.contactInfo.name,
                                      items: itemsForEmail
                                  }
                              };
                              const url = `https://files.klassik.dk/mails/index.php?token=${token}`;
              
                              fetch(url, {
                                  method: 'POST',
                                  body: JSON.stringify(payload),
                              })
                              .then((response) => {
                                  if (!response.ok) {
                                      throw new Error(`HTTP error! status: ${response.status}`);
                                  }
                                  return response;
                              })
                              .then((data) => {
                                  resolve(); 
                              })
                              .catch((error) => {
                                  console.error('Error occurred', error);
                                  reject(error); 
                              });
                          });
                      });
                  });
              }
          },
         
        }
      }
    });